import axios from "axios";
import config from "@assets/config.json"; // api 请求json

const state = {};
const mutations = {};
const getters = {};
const actions = {
  getEmailByExId({ rootState }, opt) {
    // 通过展会Id获取邮箱
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/PdLinker/page`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  addEmail({ rootState }, opt) {
    // 新增邮箱
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/PdLinker`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  getEmailById({ rootState }, id) {
    // 获取邮箱详情
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/PdLinker/?id=${id}`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  editEmailInfo({ rootState }, opt) {
    // 修改邮箱信息
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/PdLinker`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    });
  },  
  delEmailById({ rootState }, id) {
    // 删除邮箱
    return new Promise((resolve, reject) => {
      axios
        .delete(`${config.api.reqApi}/api/PdLinker?id=${id}`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  }, 
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
